module.exports = {
    "idPrimary": 867,
    companyName: "Xpresso",
    "idSchemeCode": "1f25ca6012",
    "schemeBackgroundColor": "",
    "schemeCss": "",
    "schemeLevel": "Company",
    "schemeLevelId": "d2dbadb1",
    "schemeTrimColor": "",
    "highlightColor": null,
    "schemeFontColor": "",
    "branchConfirmType": "popup",
    "signup": true,
    "headerBorder": null,
    "bodyBorder": null,
    "sectionBorder": null,
    "headerBackground": null,
    "v3HeaderBackground": null,
    "sectionBackground": "",
    "headshotBackground": null,
    "photoBackground": null,
    "helpLinkText": null,
    "headerText": null,
    "paragraphText": null,
    "subText": null,
    "coloredText": "",
    "linkText": "",
    "accountNameText": "",
    "logoBackground": null,
    "flashTextColor": null,
    "statusBarHighlightColor": "",
    "statusBarDefaultText": "",
    "statusBarDefaultBackground": "",
    "type": "loggedIn",
    "xpresso": {
        // "headerLogo": "\/next_images\/company\/1f25ca6012\/d2dbadb1_headerLogo.svg",
        "headerBanner": null,
        "apm2MobileLogo": "\/next_images\/company\/1f25ca6012\/d2dbadb1_apm2MobileLogo.svg",
        "apm2DesktopLogo": "\/next_images\/company\/1f25ca6012\/d2dbadb1_apm2DesktopLogo.svg",
        "apm2EmailLogo": "\/next_images\/company\/1f25ca6012\/d2dbadb1_apm2EmailLogo.svg",
        "headerColor": "#565656",
        "menuBackgroundColor": "#303030",
        "menuBackgroundColorShadow": "#3D3D3D",
        "menuTextColor": "#E0E7EE",
        "tileLabelColor": "#444444",
        "tileLabelTextColor": "#FFFFFF"
    }
};